import { SharedGridPadding } from "features/CenterContent/shared/MainContentGrid";
import { BusStopHeader } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopHeader";
import { BusStopTableBody } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopTableBody";
import { SimpleHeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/SimpleHeadedContainerSticky";
import { TableXS } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainRoute";
import { TableBody, TableHeader, Text } from "shared/components/Spor";
import {
  AlternativeTransportVehicle,
  StopReference,
} from "shared/types/alternativeTransport";
import { css, useTheme } from "styled-components";

const SimpleSharedGridStyleNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
`;

interface IncidentsAndStopsPanelsProps {
  vehicle: AlternativeTransportVehicle;
  distributionStopReferences: Array<StopReference>;
}

export const IncidentsAndStopsPanels = ({
  vehicle,
  distributionStopReferences,
}: IncidentsAndStopsPanelsProps) => {
  const theme = useTheme();

  return (
    <SimpleHeadedContainerSticky
      panelStyle={SimpleSharedGridStyleNoPadding}
      headerHeight="54px"
      variant="main"
      headingLeft={
        <Text variant="xs" fontWeight={600} mr="auto" p={SharedGridPadding}>
          Trasé
        </Text>
      }
    >
      <TableXS minWidth="0px">
        <TableHeader
          backgroundColor={theme.colorBackgroundTertiary}
          position="sticky"
          top="0"
          zIndex={1}
        >
          <BusStopHeader />
        </TableHeader>
        <TableBody>
          <BusStopTableBody
            id={vehicle.id}
            travelDate={vehicle.scheduledDepartureTimeOrigin}
            itinerary={vehicle.itinerary}
            vehicleStatus={vehicle.vehicleStatus}
            distributionStopReferences={distributionStopReferences}
          />
        </TableBody>
      </TableXS>
    </SimpleHeadedContainerSticky>
  );
};
